module.exports = ".image-with-effects {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 300px; }\n  .image-with-effects atn-image-input {\n    margin-right: 40px; }\n  .image-with-effects atn-array-box {\n    width: calc(100% - 242px); }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-image-with-effects-form/product-image-with-effects-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-image-with-effects-form/product-image-with-effects-form.component.scss
// module chunks = main